export default [
  {
    path: '/h5/display-download-midpage',
    component: () => import('./Page.vue'),
    meta: { title: '投放中间页-下载跳转到应用商店' },
  },
  {
    path: '/h5/display-download-midpage2',
    component: () => import('./Page2.vue'),
    meta: { title: '投放中间页-下载跳转到应用商店2' },
  },
]
